export default {
    game_state: 'initializing',
    board_rows: [],
    mine_count: 0,
    marked_cell_count: 0,
    revealed_empty_cell_count: 0,            
    total_cell_count: 0,
}